import styled from 'styled-components';

/**
 * The full width a bar may fill. Its rounded ends clip the first and last
 * segment, so the data ends are rounded and the joins between segments are
 * square, with a 2px gap of track between them.
 */
export const BarTrack = styled.div<{ $height: number }>`
  display: flex;
  gap: 2px;
  height: ${({ $height }) => $height}px;
  border-radius: ${({ $height }) => $height / 2}px;
  overflow: hidden;
  background: ${({ theme }) => theme.gray};
`;

export const BarSegment = styled.div<{ $color: string; $width: number }>`
  flex: none;
  width: ${({ $width }) => $width}%;
  /* A sliver stays visible: a real amount should never draw as nothing. */
  min-width: 4px;
  height: 100%;
  background: ${({ $color }) => $color};
`;
